import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface LocalityLookupFilter {
  searchTerm: string;
  subType: 'Locality';
}

export interface LocalityLookupResult {
  id: string;
  name: string;
  rawName: string;
  postcode?: string;
  stateAbbreviation: string;
}

export interface LocalityLookup {
  getLocations(filter: LocalityLookupFilter): Observable<{ results: LocalityLookupResult[] }>;
}

// No default factory: each app wires its own auto-search API, which differs in headers and paging.
export const LOCALITY_LOOKUP = new InjectionToken<LocalityLookup>('LOCALITY_LOOKUP');
